import React from 'react';
import VehicleManagementRouter from './VehicleManagementRouter';

export default function VehicleManagementPage() {
  return <VehicleManagementRouter />;
}
